import { MessageCircle, Star, ExternalLink } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { FinalCTA } from "../sections/HomeBlocks2";
import { BUSINESS } from "../data/content";

export default function Reviews() {
  return (
    <main>
      <PageHeader
       
        lines={["Just getting started —", "and glad to prove it."]}
        sub="BHF Creative is a new studio, so there are no reviews here yet. We think that honesty is worth more than a wall of fabricated praise."
      />

      <section className="pb-24" data-testid="reviews-page">
        <div className="container-x max-w-3xl">
          <Reveal>
            <div className="card p-9 hover:!transform-none">
              <h2 className="text-[clamp(22px,2.6vw,30px)]">Be one of our first featured clients.</h2>
              <p className="text-[#A0A3C2] mt-4 leading-relaxed">
                Every studio starts at zero. Ours starts with a promise: work with us now, and
                you get our fullest attention  and a permanent spot on this page when your
                project ships. Message us on WhatsApp and let's make you review number one.
              </p>
              <div className="flex flex-wrap gap-4 mt-8">
                <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="reviews-page-whatsapp-btn" className="btn btn-wa no-underline">
                  <MessageCircle size={17} /> Start on WhatsApp
                </a>
                <a href={BUSINESS.googleReviewLink} data-testid="google-review-invite-link" className="btn btn-ghost no-underline">
                  Leave a Google review <ExternalLink size={15} />
                </a>
              </div>
              
            </div>
          </Reveal>

          
        </div>
      </section>
      <FinalCTA />
    </main>
  );
}
